import { render, staticRenderFns } from "./SimpleNote.vue?vue&type=template&id=56ebe0c2&"
import script from "./SimpleNote.vue?vue&type=script&lang=js&"
export * from "./SimpleNote.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports